import Alert from "@imminently/decisively-ui/Alert";
import Icon from "@imminently/decisively-ui/Icon";
import type { SanitizedFieldInfo } from "@packages/commons";

interface ExportSanitizationAlertProps {
  fields: SanitizedFieldInfo[];
}

const getValueLabel = (value: unknown) => {
  if (typeof value === "string") return value;
  return JSON.stringify(value);
};

const getOriginalValueLabel = (field: SanitizedFieldInfo) => {
  if (field.secret) return "Secret value removed";
  if (field.value !== undefined) return getValueLabel(field.value);
  return undefined;
};

export const ExportSanitizationAlert = ({ fields }: ExportSanitizationAlertProps) => (
  <Alert
    variant="warning"
    icon={<Icon name="warning" />}
    description={
      <>
        This export omitted environment-specific fields:
        <ul className="mt-2 list-disc pl-5">
          {fields.map((field) => (
            <li key={field.key}>
              <strong>{field.displayName}</strong>
              {getOriginalValueLabel(field) ? <span className="ml-2">{getOriginalValueLabel(field)}</span> : null}
              <div>{field.description}</div>
            </li>
          ))}
        </ul>
      </>
    }
  />
);
